// extracted by mini-css-extract-plugin
export default {"VerifiedPopoverContent":"VerifiedPopoverContent_VerifiedPopoverContent__9kihT","Link":"VerifiedPopoverContent_Link__nKOIa"};